export class Primary {
	constructor() {
		this.name = 'Primary'
		this.content = {
      zoom: 5,
      lat: 38,
      lng: -99,
      mapType: 'roadmap',
      mapStyle: [],
      markers: []
		}
    this.view = this.viewHtml()
	}

	viewHtml() {
    return `<div
			>Google maps</div>`
	}

	classes() {
		return [
      {property: 'Rounded', value: 'ROUNDED_LG'},
      {property: 'Border', value: 'ROUNDED_LG'},
      {property: 'Shadow', value: 'SHADOW_MD'},
		]
	}

	styles() {
    return [
      {property:'Height', styleProperty: 'height', value: '400px'}
    ]
  }

	buildData() {
		return {
			name: this.name,
			view: this.view,
		}
	}

	editorProperties() {
		return {
			content: this.content,
      styles: {
        phone: this.styles(),
        tablet: this.styles(),
        desktop: this.styles(),
      },
			classes: {
				phone: this.classes(),
				tablet: this.classes(),
				desktop: this.classes(),
			},
		}
	}
}
